/**
 * adapted from https://netbasal.com/disabling-form-controls-when-working-with-reactive-forms-in-angular-549dd7b42110
 * in order to get rid of 'It looks like you’re using the disabled attribute with a reactive form directive.' warning
 */
import { Directive, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[disableControl]'
})
export class DisableControlDirective implements OnInit {
    constructor(
        private ngControl: NgControl
    ) {
    }

    @Input() public set disableControl(condition: boolean) {
        if (this.disabled !== undefined) {
            this.toggleForm(condition);
        }
        this.disabled = condition;
    }

    private disabled: boolean;

    public ngOnInit() {
        this.toggleForm(this.disabled);
    }

    private toggleForm(condition: boolean) {
        const action = condition ? 'disable' : 'enable';

        this.ngControl.control[action]();
    }
}
